import { createContext, useState } from "react"

export const schoolContext = createContext();

export const SchoolContextProvider = ({ children }) => {
    const [schoolDetails, setSchoolDetails] = useState({});
    const [topperStudents, setTopperStudents] = useState([]);

    return (
        <schoolContext.Provider value={{ schoolDetails, setSchoolDetails, topperStudents, setTopperStudents }}>
            {children}
        </schoolContext.Provider>
    )

}   